/**
 * Build-time configuration flags derived purely from environment variables.
 *
 * This module is intentionally dependency-free — it imports nothing from the
 * Redux store, i18n, MUI or aws-amplify. That makes it safe to import from
 * low-level modules such as the i18n bootstrap (`src/i18n.ts`) and the locale
 * helpers (`src/utils/localeTag.ts`) without reintroducing an import cycle or
 * pulling heavy side effects into module-load time.
 *
 * `src/utils.ts` re-exports these flags so existing `from './utils'` imports
 * keep working; new low-level code should import directly from here.
 */

/** Corporate single-bundle wallet build (opt-in via the `build:corporate` script). */
export const corporateWalletFlag = process.env.REACT_APP_CORPORATE_WALLET === '1';

/** Render the CSS gradient background instead of the image background. */
export const cssBackgroundFlag = process.env.REACT_APP_CSS_BACKGROUND === '1';
